module.exports = __webpack_public_path__ + "static/media/NewDesignFile.efcf91e5.svg";